import { Card, Chip, Grid, Stack } from "@mui/material";
import SoftBox from "components/SoftBox";
import React, { useEffect, useState } from "react";
import TypeModal from "./components/Modals/TypeModal";
import PageLayout from "examples/LayoutContainers/PageLayout";
import dataTableData from "./components/data/type";
import DataTable from "./components/DataTable";
import SoftTypography from "components/SoftTypography";
import Loader from "examples/Loader";
import { Add, TipsAndUpdates } from "@mui/icons-material";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";

function Type() {
  const { data, processing, handleRefresh, main_data } = dataTableData();
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();
  const [loader, setLoader] = useState(true);
  const [suggestion, setSuggestion] = useState(false);
  const [superadmin_data, setsuperadmin_data] = useState([]);
  const GetSettings = async () => {
    const { response } = await AppService.notes_type.getsettings();
    if (response) {
      setLoader(false);
      setsuperadmin_data(response.data);
    } else {
      setLoader(false);
    }
  };
  const onLoad = () => {
    GetSettings();
  };
  useEffect(() => {
    onLoad();
  }, []);
  const handleSubmit = async (category) => {
    const payload = {
      title: category.title,
      agency_id: agency._id,
    };
    const { response } = await AppService.notes_type.create({
      payload,
      toaster: true,
    });
    if (response) {
      handleRefresh();
    }
  };
  return (
    <PageLayout>
      {loader ? (
        <Loader />
      ) : (
        <Card
          sx={{
            boxShadow: "0 3px 5px 0 rgba(0,0,0,.06)",
            border: "1px solid #cfd7df",
            borderRadius: "8px",
            marginRight: "1em"
          }}
        >
          <SoftBox p={3}>
            <SoftTypography variant="h5">Notes </SoftTypography>
          </SoftBox>
          <Grid container p={5} rowSpacing={3}>
            <Grid item xs={12} display={"flex"} justifyContent={"flex-end"}>
              <SoftBox mr={1}>
                <TipsAndUpdates
                  sx={{ cursor: "pointer" }}
                  onClick={() => setSuggestion(!suggestion)}
                />
              </SoftBox>
              <TypeModal handleRefresh={handleRefresh} />
            </Grid>
            {suggestion && (
              <Grid>
                <Stack direction="row" spacing={1}>
                  {superadmin_data
                    .filter(
                      (item) => !main_data?.some((main_data) => main_data?.title === item?.title)
                    )
                    .map((category) => (
                      <Chip
                        key={category._id}
                        label={category?.title}
                        icon={<Add />}
                        onClick={() => handleSubmit(category)}
                        sx={{ cursor: "pointer" }}
                        variant="outlined"
                      />
                    ))}
                </Stack>
              </Grid>
            )}
            <Grid item xs={12}>
              <DataTable table={data} canSearch />
            </Grid>
          </Grid>
        </Card>
      )}
    </PageLayout>
  );
}

export default Type;
